import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";

import { useDispatch, useSelector } from "react-redux";
import { LabelTemplateTab } from "./LabelTemplateTab";
import { MasterTab } from "./MasterTab";
import { PreferencesTab } from "./PreferencesTab";
import { checkMenu } from "../../utility";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
import { MenuTab } from "../menu/MenuTab";
import {
  selectTabMaster,
  setPermisionLabelTemplate,
  setPermisionPreference,
  setTabMaster,
} from "./motorPoolSlice";
import { useLocation } from "react-router";

export const MotorPoolPage = (params) => {
  const dispatch = useDispatch();
  const dataMenuTab = useSelector(selectMenuTab);
  const [active, setActive] = useState("");
  const [list, setList] = useState(null);
  const location = useLocation();


  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchMenuTab({
          menu_url: "/administration/motor-pool",
        })
      );
      await dispatch(
        fetchParameter({
          paramgroup_code: "COUNTRY",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      setActive(data[0]);

      if (location.pathname === "/administration/motor-pool/label") {
        setActive("Label Template");
      } else if (location.pathname === "/administration/motor-pool/preferences") {
        setActive("Preferences");
      } else {
        setActive(data[0]);
      }

      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Masters") {
          return dispatch(setTabMaster(item));
        }
        if (item.menu_name === "Label Template") {
          return dispatch(setPermisionLabelTemplate(item.permissions));
        }
        if (item.menu_name === "Preferences") {
          return dispatch(setPermisionPreference(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  return (
    <>
      {list && (
        <div>
          <Tabs
            // defaultActiveKey="Label Template"
            id="uncontrolled-tab-example"
            activeKey={active}
            onSelect={(e) => {
              setActive(e);
            }}
          >
            {checkMenu(list, "Label Template") && (
              <Tab eventKey="Label Template" title="Label Template">
                <LabelTemplateTab active={active} />
              </Tab>
            )}
            {checkMenu(list, "Masters") && (
              <Tab eventKey="Masters" title="Masters">
                <MasterTab />
              </Tab>
            )}
            {checkMenu(list, "Preferences") && (
              <Tab eventKey="Preferences" title="Preferences">
                <PreferencesTab />
              </Tab>
            )}
          </Tabs>
        </div>
      )}
    </>
  );
};
